import React from 'react'

import Button from './Button'
import EllipsisIcon from '../../../assets/icons/ellipsis.svg?react'
import BottomDrawer from '../layout/BottomDrawer'
import Dropdown from './Dropdown'

type Props = {
  disabled?: boolean
  items: Array<{ id: string, item: React.ReactElement, disabled?: boolean }>
}

const MoreActionsButton: React.FC<Props> = ({ disabled, items }) => {
  const [showBottomDrawer, setShowBottomDrawer] = React.useState(false)

  const renderButton = (onClick: () => void) => {
    return (
      <Button disabled={disabled} onClick={onClick} size='sm' variant='flat'>
        <EllipsisIcon width={28} height={28} className='stroke-electric-green rotate-90' />
      </Button>
    )
  }
  return (
    <>
      <div className='inline-block sm:hidden'>{renderButton(() => setShowBottomDrawer(true))}</div>
      <div className='hidden sm:inline-block'>
        <Dropdown originRight items={items}>
          {renderButton(() => {})}
        </Dropdown>
      </div>
      {showBottomDrawer && (
        <BottomDrawer onClose={() => {setShowBottomDrawer(false)}}>
          <div className='flex flex-col items-start gap-y-2 p-2'>
            {items.map((item) => (
              <div key={item.id}>
                {item.item}
              </div>
            ))}
          </div>
        </BottomDrawer>
      )}
    </>
  )
}

export default MoreActionsButton
